<template>
  <div class="setting">
    <h4>{{ name }}</h4>
    <div><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: 'AppSetting',
  props: {
    name: String
  },
  setup () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.setting {
  margin: 1rem 0;
  justify-content: space-between;
  align-items: center;
  display: flex;
  h4 {
    margin: 0;
  }
}
</style>